import api from "../proxy/config";
import axios from "./axiosConfig";

const getHeaders = () => ({
    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

const handleBackendError = (error, defaultMsg) => {
    if (error.response?.status === 500 || (typeof error.response?.data === 'string' && error.response.data.includes("Internal Server Error"))) {
        throw new Error("Si è verificato un problema, riprova più tardi.");
    }
    const backendError = error.response?.data;
    const message = typeof backendError === 'string' 
        ? backendError 
        : (backendError?.message || backendError?.error || defaultMsg);
    throw new Error(message);
};

export const getEcomByFilter = async (value, page, size, sortDirection = "asc", status = null) => {
    try {
        const response = await axios.post(api.ricercaVendors, {
            searchFieldValue: value,
            limit: size,
            offset: page * size,
            stato: status,
            ordinamento: sortDirection.toUpperCase()
        }, {
            headers: getHeaders(),
        });

        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante il recupero degli e-commerce");
    }
}

export const updateEcom = async (data) => {
    try {
        const response = await axios.post(api.modificaVendor, data, {
            headers: getHeaders(),
        });

        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante la modifica dell'e-commerce");
    }
}

export const getVendorPaymentMethods = async (vendorId) => {
    try {
        const response = await axios.post(api.vendorPaymentMethods(vendorId), {}, {
            headers: getHeaders(),
        });

        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante il recupero dei metodi di pagamento");
    }
}

export const getAdminLogs = async (vendorId, page, size) => {
    try {
        const response = await axios.post(api.storicoVendors, {
            vendorId,
            offset: page * size,
            limit: size
        }, {
            headers: getHeaders(),
        });

        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel recupero dello storico azioni");
    }
}

export const rollbackVendor = async (logId, fieldsToRestore) => {
    try {
        const response = await axios.post(`${api.rollbackVendor}/${logId}`, fieldsToRestore || [], {
            headers: getHeaders(),
        });

        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante il ripristino dell'e-commerce");
    }
}

 